<template>
  <v-row class="mx-auto ">
    <v-col :style="{ 'padding-left': padding }">
      <v-col  cols="12"
        md="8"
        sm="6"
        xs="4"
        style="max-width: 100%"
        class="d-flex justify-space-between mx-auto">
        <v-btn-toggle
          group
          tile
          color="indigo lighten-2 accent-3"
          v-model="buttonSelected"
        >
          <v-btn @click="showHolidayGroup">{{ "Elements" }}</v-btn>
          <v-btn @click="showHolidays">{{ "DFIS" }}</v-btn>
        </v-btn-toggle>
        <ToolbarTitles />
      </v-col>
      <div v-if="buttonSelected === 0" class="container">
        <Elements :showCard="showCard" />
      </div>
      <div v-else-if="buttonSelected === 1" class="container">
        <DFIS :showCard="showCard" />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import ToolbarTitles from "@/components/Complement/ToolbarTitles.vue";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import Elements from "./Elements.vue";
import Loader from "@/components/Complement/Loader.vue";
import DFIS from "./DFis.vue";
import accessPermissions from "../../../store/permisosDeAcceso/accessPermissions";
export default {
  components: {
    DFIS,
    Elements,
    Loader,
    ToolbarTitles,
    ButtonsCardList,
  },
  data() {
    return {
      buttonSelected: 0,
      isLoading: true,
      showCard: true,
    };
  },
  computed: {
    padding() {
      return accessPermissions.state.paddingNav;
    },
  },
  methods: {
    cardView(value) {
      this.showCard = value;
    },
    showHolidayGroup() {
      this.isLoading = true;
      this.$nextTick(() => {
        this.buttonSelected = 0;
        this.isLoading = false;
      });
    },
    showHolidays() {
      this.isLoading = true;
      this.$nextTick(() => {
        this.buttonSelected = 1;
        this.isLoading = false;
      });
    },
  },
};
</script>
<style>
.container {
  max-width: 100%;
}
</style>
